import { Validators } from '@angular/forms';
import { FormControlOptions } from '@miq/catalog';

export const LeaseSaleFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  layout_cbre_f: {
    name: 'layout_cbre_f',
    type: 'control',
  },
  // Associated Alternate address for insert mode
  alternate_address_id: {
    name: 'alternate_address_id',
    type: 'control',
  },
  // Associated Alternate address
  alternate_address: {
    name: 'alternate_address',
    type: 'group',
    controlsConfig: {
      id: [null],
      full_street_name: [null],
      latitude: [null],
      longitude: [null],
      major_corridor_type_desc: [null],
      action: [null],
    },
  },
  // Arrangement options
  arrangement_options: {
    name: 'arrangement_options',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
      arrangement_option_start_date: [null],
      arrangement_option_type_desc: [null],
      arrangement_option_executor_type_desc: [null],
      arrangement_option_detail: {
        type: 'array',
        name: 'arrangement_option_detail',
        controlsConfig: {
          id: [null],
          _mode: [null],
          option_comment: [null],
          option_type_desc: [null],
          rights_option_start_date: [null],
        },
      },
    },
  },
  // Escalation Details
  rent_escalation_custom: {
    name: 'rent_escalation_custom',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: ['update'],
      edited: [''],
      escalation_period: [null, [Validators.required, Validators.maxLength(20)]],
    },
  },
  // Measurements
  property_measurement_arrangement: {
    type: 'array',
    name: 'property_measurement_arrangement',
    controlsConfig: {
      id: [''],
      _mode: [''],
    },
  },
  // Yield
  arrangement_yield_detail: {
    type: 'array',
    name: 'arrangement_yield_detail',
    controlsConfig: {
      id: [''],
      _mode: [''],
    },
  },
  // Company contacts
  company_contact_role_addresses: {
    name: 'company_contact_role_addresses',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: [null],
      _contact_id: [null], // ensure presence
      display_order: [null], // ensure presence
      prev_display_order: [null], // ensure presence
      company_id: [null], // ensure presence
      familiar_name: [null],
      role_desc: [null],
      contact_id: [null], // ensure presence
      location_id: [null], // ensure presence - flat mirror of location.location_id (MIQ-36890)
      children: [],
    },
    children: {
      location: {
        name: 'location',
        type: 'group',
        controlsConfig: { location_id: [null] },
      },
      company_industry_classification: {
        name: 'company_industry_classification',
        type: 'array',
        controlsConfig: {
          id: [null],
          ref_naics_classification_desc: [null],
          primary_naics_code_f: [null],
          _mode: [null], // required by NAICS code conditional fields
        },
      },
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: {
          id: [null],
          _mode: [null],
          country_code_desc: [null],
          language_desc: [null],
        },
      },
    },
  },
  // Lease Comp Notes
  arrangement_notes: {
    type: 'array',
    name: 'arrangement_notes',
    controlsConfig: {
      id: [''],
    },
  },
  floor_suite: {
    type: 'array',
    name: 'floor_suite',
    children: {
      // Associated Alternate address
      alternate_address: {
        name: 'alternate_address',
        type: 'group',
        controlsConfig: {
          id: [null],
          full_street_name: [null],
          latitude: [null],
          longitude: [null],
          major_corridor_type_desc: [null],
          _mode: [null],
        },
      },
    },
    controlsConfig: {
      id: [null],
      alternate_address_id: [null],
    },
  },
  // Property
  property: {
    name: 'property',
    type: 'group',
    children: {
      property_usage: {
        name: 'property_usage',
        type: 'group',
        controlsConfig: {
          id: [null],
          ref_property_usage_type_desc: [null],
        },
      },
      property_external_ratings: {
        name: 'property_external_ratings',
        type: 'array',
        controlsConfig: { id: [null], _mode: [null] },
      },
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: {
          country_code_desc: [null],
          language_desc: [null],
          id: [null],
          _mode: [null],
        },
      },
      postal_address: {
        name: 'postal_address',
        type: 'group',
        controlsConfig: {
          country: [null],
          longitude: [null],
          latitude: [null],
        },
        children: {
          colloquial: {
            name: 'colloquial',
            type: 'array',
            controlsConfig: {
              country_code_desc: [null],
              language_desc: [null],
              id: [null],
              _mode: [null],
            },
          },
        },
      },
      alternate_postal_addresses: {
        name: 'alternate_postal_addresses',
        type: 'array',
        controlsConfig: {
          id: [null],
        },
      },
    },
  },
  //Brand
  brand: {
    name: 'brand',
    type: 'array',
    controlsConfig: {
      id: [null],
      brand_id: [null, [Validators.required]],
      brand_name: [null],
      business_category_desc: [null],
      _mode: [null],
      table_id: [null],
    },
  },
  //Lease Comp Prior Location
  arrangement_prior_location: {
    type: 'array',
    name: 'arrangement_prior_location',
    controlsConfig: {
      id: [null],
      property_id: [null],
      property_usage_id: [null],
      _mode: [null],
    },
    children: {
      lig_geography: {
        type: 'group',
        name: 'lig_geography',
        controlsConfig: {
          id: [null],
          _mode: [null],
        },
      },
    },
  },
  //Lease Comp Move From Location
  source_prior_location: {
    type: 'array',
    name: 'source_prior_location',
    controlsConfig: {
      id: [null],
      _mode: [null],
      market_desc: [null],
      market_comment: [null],
      submarket_desc: [null],
      submarket_comment: [null],
      global_region_desc: [null],
      division_desc: [null],
    },
  },
  colloquial: {
    name: 'colloquial',
    type: 'array',
    controlsConfig: {
      country_code_desc: [null],
      language_desc: [null],
      id: [null],
      _mode: [null],
    },
  },
  miqProperties: {
    name: 'miqProperties',
    type: 'group',
    children: {
      calculated_fields: {
        name: 'calculated_fields',
        type: 'group',
        controlsConfig: {
          gdv_per_bed: [null],
        },
      },
    },
  },
  lease_frontage: {
    name: 'lease_frontage',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  arrangement_apn_number: {
    name: 'arrangement_apn_number',
    type: 'array',
    controlsConfig: { hist_apn_number: [null], id: [null], _mode: [null] },
  },
});
